import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EditBookSummaryPopup from "./editSummaryPopup";
import { takeOverviewDraft } from "./overviewDraft";

const EditSummaryPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { summaryId } = useParams();

  // The list hands over the URL it was showing, so finishing an edit returns
  // to that page of results rather than dropping the lister back on page 1.
  // A direct link here carries no state, hence the plain fallback.
  const returnTo = location.state?.returnTo || "/summary";
  const goBack = () => navigate(returnTo);

  // "Open in summary" on an AI testing run. Taken in an effect, not during
  // render: taking deletes the draft, and a render React throws away would
  // otherwise consume it. Deleted as it is read, so a reload shows the saved
  // summary. Bound to this summary — a link pasted onto another is ignored.
  const draftId = new URLSearchParams(location.search).get("overviewDraft");
  const [overviewDraft, setOverviewDraft] = useState(null);
  useEffect(() => {
    if (!draftId) return;
    const draft = takeOverviewDraft(draftId, summaryId);
    if (draft) setOverviewDraft(draft);
    else toast.warn("That AI testing run is no longer available here — this is the saved summary.");
  }, [draftId, summaryId]);

  return (
    <EditBookSummaryPopup
      summaryId={summaryId}
      isModalVisible={true}
      isPageView={true}
      closeModal={goBack}
      onSuccess={goBack}
      overviewDraft={overviewDraft}
    />
  );
};

export default EditSummaryPage;
